module.exports = __webpack_public_path__ + "img/logogu.24a10038.png";